import { useEffect } from "react";

import { Card, Hr } from "@icg360/design-system";

import SignatureSection from "pages/overview/welcome-banner/signature-section";
import { UnderwritingSection } from "pages/overview/welcome-banner/underwriting-section";
import { trackEvent } from "utils";

import { BillingSection } from "./billing-section";
import styles from "./welcome-banner.module.scss";

const WelcomeBanner = () => {
  useEffect(() => {
    trackEvent("welcomeTaskCard_load");
  }, []);

  return (
    <Card className={styles.welcomeCardDS}>
      <div className={styles.welcomeSections}>
        <BillingSection />
        <div className={styles.stackedDivider}>
          <Hr spacing="xl" />
        </div>
        <SignatureSection />
        <div className={styles.stackedDivider}>
          <Hr spacing="xl" />
        </div>
        <UnderwritingSection />
      </div>
    </Card>
  );
};

export { WelcomeBanner };
